import { useEffect, useState, useContext } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { useFormik } from 'formik'

import * as Yup from 'yup'

import { Context } from 'contexts/context'

import TitleBar from 'components/TitleBar'
import Content from 'components/Content'
import Card from 'components/Card'
import Upload from 'components/Form/Upload'
import CardTitle from 'components/CardTitle'
import Input from 'components/Form/LabelInput'
import BtnBlue from 'components/Button/BtnBlue'
import Messages from 'components/Messages'
import Spinner from 'components/Spinner'
import BtnOrange from 'components/Button/BtnOrange'
import CardBody from 'components/CardBody'
import BtnRed from 'components/Button/BtnRed'
import BtnBox from 'components/Button/BtnBox'
import Select from 'components/Form/LabelSelect'
import BtnWhite from 'components/Button/BtnWhite'
import Modal from 'components/Modal'

import { handleChatbotShow, handleChatbotUpdate, handleChatbotDelete, handleChatbotModel } from 'services/api/chatbot'
import { handleCards } from 'services/api/reportCards'

const validation = yup => ({
  name: yup.string()
    .required('Campo obrigatório')
})

const DEFAULT_PROMPT = `
A pergunta foi: [QUESTION].

Os dados obtidos pelo Power BI são: [DATA].

Faça uma análise clara e objetiva, como se estivesse explicando a um executivo.

Inclua se houve crescimento ou queda, e a porcentagem de variação. Não invente valores.
`

const NewReportCollection = () => {
    const [data, setData] = useState({})
  
    const { user: { firm_id } } = useContext(Context)

    const [visibleModal, setVisibleModal] = useState(false)
    const [messages, setMessages] = useState({ messages: [], alert: '' })

    const [messagesFile, setMessagesFile] = useState('')
    const [done, setDone] = useState(true)
    const [errors, setErrors] = useState([])

    const history = useHistory()
    const params = useParams()

    const formik = useFormik({
      initialValues: { 
        name: data.name,
        prompt: data.prompt ? data.prompt : DEFAULT_PROMPT,
        instructions: data.instructions
      },
      enableReinitialize: true,
      validationSchema: Yup.object(validation(Yup)),
      onSubmit: async () => handleChatbotUpdate(history, { ...formik.values }, params.id, setMessages)
    })

    useEffect(() => {
      (async () => {
        try {
          setDone(true)
          setData(await handleChatbotShow(params.id))
          setDone(false)
        } catch(error) {}
      })()
    }, [params.id])

    const handleDelete = async () => handleChatbotDelete(params.id, history)

    const files = async files => {
      setMessagesFile('')
      setErrors([])
      setDone(true)
      await handleChatbotModel(files[0], params.id)
      setData(await handleChatbotShow(params.id))
      setDone(false)
    }

    return (
        <>
        <TitleBar label="Chatbot" currentPage="" />

        <Content>
          <Card>
            <CardTitle title="Editar">
              <BtnOrange onClick={() => setVisibleModal(true)}>Excluir</BtnOrange>
            </CardTitle>

            <Content>
              <CardBody>
                <form onSubmit={formik.handleSubmit}>
                  <Messages formMessages={messages.messages} alert={messages.alert} />

                  <Input type="" name="name" label="Nome" formik={formik} />
                  
                  <Input isTextArea name="prompt" label="Prompt" formik={formik} />
                  <Input isTextArea name="instructions" label="Instruções" formik={formik} />
                  
                <BtnBox>
                  <BtnBlue type="submit" disabled={formik.isSubmitting}>
                    {formik.isSubmitting ? <Spinner /> : "Enviar"}
                  </BtnBlue>
                </BtnBox>
                </form>
              </CardBody>
            </Content>
          </Card>

          <Card>
          <CardTitle title="Modelo"></CardTitle>

          <Content>
            <CardBody>
              <Upload
                isJson
                onUpload={files}
                fileUrl={data.file_url}
                modelo={data.model}
                done={done}
                errors={errors}
                setErrors={setErrors}
              />
              <p>{messagesFile}</p>
            </CardBody>
          </Content>
        </Card>
        </Content>

        <Modal visibleModal={visibleModal} setVisibleModal={setVisibleModal}>
          <Card>
            <Content>
              <Content>
                <CardBody>
                  <p>Deseja excluir esta coleção de relatórios?</p>

                  <BtnBox>
                    <BtnRed onClick={handleDelete}>Excluir</BtnRed>
                    <BtnWhite onClick={() => setVisibleModal(false)}>Cancelar</BtnWhite>
                  </BtnBox>
                </CardBody>
              </Content>
            </Content>
          </Card>
        </Modal>
      </>
    )
}

export default NewReportCollection